import type { ChartDataPoint } from 'pages/Analytics/MarketOpportunity/api/useMarketOpportunity/useMarketOpportunity';

export function cropZeroData(data?: ChartDataPoint[]) {
  if (!data) {
    return data;
  }
  return data.filter((item, index) => !(item.value === 0 && index > data.length - 5));
}
